






import Vue from 'vue'
export default Vue.extend({
  name: 'nav-item',
  props: {
    path: {
      type: String,
      default: '#'
    },
    text: {
      type: String,
      default: 'Link'
    }
  }
})
